import React from 'react'
import AdminDetailsUserContainer from '../../modules/GAAdminUsers/containers/AdminDetailsUserContainer/AdminDetailsUserContainer'

const GAAdminUsersDetails = () => {
  return (
    <AdminDetailsUserContainer />
  )
}

export default GAAdminUsersDetails